import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouchWithCarServiceConnecticut from "./sections/GetInTouchWithCarServiceConnecticut";
import ContactInformation from "./sections/ContactInformation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouchWithCarServiceConnecticut />
      <ContactInformation />
      <Footer />
    </div>;
}